import Vue from "vue";
import VueRouter from "vue-router";

import moduleRouters from "@/module/router";
import authPlugin from "@/plugins/auth";

import {
  crmUrl
} from "@/config/customization";

const Login = resolve => require(["@/components/login/Login.vue"], resolve);
const Login1 = resolve => require(["@/components/login/Login1.vue"], resolve);
const Register = resolve => require(["@/components/register/register.vue"], resolve);

const ForgetPassword = resolve => require(["@/components/login/ForgetPassword.vue"], resolve);
const Main = resolve => require(["@/components/main/Main.vue"], resolve);
const Main1 = resolve => require(["@/components/main/Main1.vue"], resolve);
const Home = resolve => require(["@/module/home/Home.vue"], resolve);
const Home1 = resolve => require(["@/module/home/Home1.vue"], resolve);
const Unauthorized = resolve => require(["@/components/401.vue"], resolve);
const NotFound = resolve => require(["@/components/404.vue"], resolve);
const InternalServerError = resolve =>
  require(["@/components/500.vue"], resolve);
const Auth = resolve => require(["@/components/auth.vue"], resolve); //<!--停止使用-->
const Authorize = resolve => require(["@/components/authorize.vue"], resolve);
const IFrameContainer = resolve =>
  require(["@/components/external/IFrameContainer.vue"], resolve);

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [{
    path: "/main",
    redirect: {
      name: "login"
    },
    component: Main,
    children: [{
      path: "external/:url",
      name: "external",
      component: IFrameContainer
    }]
  },
  {
    path: "/login",
    name: "login",
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: Login
  },
  {
    path: "/login1",
    name: "login1",
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: Login1
  }, {
    path: "/forget",
    name: "forget",
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: ForgetPassword
  },
  {
    path: "/401",
    name: "401",
    component: Unauthorized,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/500",
    name: "500",
    component: InternalServerError,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/auth/:userId/:targetUrl",
    name: "auth",
    component: Auth,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/authorize",
    name: "authorize",
    component: Authorize,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/register/:inviteid",
    name: "register",
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: Register
  },
  ...generateRoutesFromModules(),
  {
    path: "*",
    redirect: "/404"
  }
  ]
});

//注册一个全局的 before 钩子，对于需要登录才能访问的模块进行控制进行控制
router.beforeEach((to, from, next) => {
  const isStore = router.app.$options.store.state.isStore;
  const auth = router.app.$options.store.state.auth;
  //false:非商场，1true：商场
  if (to.name == "home1" || to.name == "login1") {
    if (isStore == true) {
      next({
        name: "home",
      });
    }
  }

  if (to.name == "home" || to.name == "login") {
    if (isStore == false) {
      to.meta.allowAnonymous = false;
      if (!auth.isLoggedIn) {
        //如果没有登录，则跳到登录页面
        next({
          name: "login1",
        });
      } else {
        //如果已经登录，则判断是否有页面访问权限
        next({
          name: "home1",
        });
      }
    }
  }
  if (to.meta && to.meta.allowAnonymous) {
    if (to.name === "auth" || to.name === "authorize") {
      authPlugin.clearAllData();
    }
    next();
    return;
  }
  // next();

  //针对嵌入到CRM的页面的处理
  if (to.name.contains("crm__")) {
    guardCrmRoute(to, from, next);
    return;
  }

  if (to.name&&to.name != "login1"&&!isStore && !auth.isLoggedIn) {
    next({
      name: "login1",
    });
  }
  // if (isStore == false) {
  //   to.matched[0].components.default = Main1
  // }

  //针对PORTAL页面的处理
  if (isStore === true) {
    guardRoute(to, from, next);
  } else {
    guardStoreRoute(to, from, next);
  }

});

function guardStoreRoute(to, from, next) {
  //如果是非Portal用户登录产生的auth,直接退出重新登录
  const user = router.app.$options.store.state.user;
  if (user != null && user.loginType != null && user.loginType == "sso_mscrm") {
    authPlugin.logout();
    return;
  }

  const auth = router.app.$options.store.state.auth;
  //判断有没有登录
  if (!auth.isLoggedIn) {
    //如果没有登录，则跳到登录页面
    if (to.name === "home") {
      next({
        name: "login1",
      });
    } else {
      next({
        name: "login1",
      });
    }
  } else {
    //如果已经登录，则判断是否有页面访问权限
    if (hasPermission(to)) {
      next();
    } else {
      next({
        name: "401"
      });
    }
  }

}

function generateRoutesFromModules() {
  return moduleRouters;
}

function guardCrmRoute(to, from, next) {
  if (from.fullPath == "/") {
    authPlugin.clearAllData();
  }
  const auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    var redirectUrl =
      location.origin +
      location.pathname +
      "#/authorize?redirect_url=" +
      encodeURIComponent(to.path);
    var data = encodeURIComponent(
      "redirect_url=" + encodeURIComponent(redirectUrl)
    );
    //var data = encodeURIComponent("redirect_url=" + encodeURIComponent(to.path));

    window.location.href =
      crmUrl + "/WebResources/new_/connect/authorize.html?Data=" + data;
  } else {
    next();
  }
}

function guardRoute(to, from, next) {
  console.log("nosrore");


  //如果是非Portal用户登录产生的auth,直接退出重新登录
  const user = router.app.$options.store.state.user;
  if (user != null && user.loginType != null && user.loginType == "sso_mscrm") {
    authPlugin.logout();
    return;
  }

  const auth = router.app.$options.store.state.auth;
  //判断有没有登录
  if (!auth.isLoggedIn) {
    //如果没有登录，则跳到登录页面
    if (to.name === "home") {
      next({
        name: "login",
      });
    } else {
      next({
        name: "login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    //如果已经登录，则判断是否有页面访问权限
    if (hasPermission(to)) {
      next();
    } else {
      next({
        name: "401"
      });
    }
  }
}

function hasPermission(router) {
  //页面需要的权限列表
  var requiredPermissions = router.meta && router.meta.requiredPermissions;
  if (!requiredPermissions || requiredPermissions.length == 0) {
    return true;
  }

  //当前用户授权的权限列表
  var userPermissions = window.GLOBAL_USER_ACTIONS || [];
  if (userPermissions.length == 0) {
    return false;
  }

  for (var i = 0; i < requiredPermissions.length; i++) {
    var isMatched = false;
    for (var j = 0; j < userPermissions.length; j++) {
      if (requiredPermissions[i] == userPermissions[j]) {
        isMatched = true;
      }
    }

    //页面需要的权限，只要有一个不满足，就返回false
    if (!isMatched) {
      return false;
    }
  }

  return true;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js